import React from 'react';

export default function VeylLogo({ width = 200, showSpark = false, centered = false }) {
  const gradientId = 'veyl-gradient';
  const aspectRatio = 400 / 155;
  const height = width / aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 155"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', overflow: 'visible' }}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%"   stopColor="#008081" />
          <stop offset="55%"  stopColor="#41767c" />
          <stop offset="100%" stopColor="#4B2C5E" />
        </linearGradient>
      </defs>

      <text
        x={centered ? "200" : "0"}
        y="140"
        textAnchor={centered ? "middle" : "start"}
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'Helvetica Neue', Arial, sans-serif"
        fontSize="155"
        fontWeight="800"
        letterSpacing="-4"
        fill={`url(#${gradientId})`}
      >
        Veyl
      </text>

      {showSpark && (
        <text x="370" y="150" fontSize="22" fill="rgba(255,255,255,0.5)">✦</text>
      )}
    </svg>
  );
}